import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Layout from './layouts/Layout';
import ComingSoon from './pages/ComingSoon';
import Home from './pages/Home';
import Shop from './pages/Shop';
import PatternPage from './pages/shop/PatternPage';
import About from './pages/About';
import FAQ from './pages/FAQ';
import ThankYou from './pages/ThankYou';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogTag from './pages/BlogTag';
import SignIn from './pages/SignIn';
import Dashboard from './pages/admin/Dashboard';
import AdminPatterns from './pages/admin/Patterns';
import PatternPreview from './pages/admin/PatternPreview';
import AdminBundles from './pages/admin/Bundles';
import AdminTutorials from './pages/admin/Tutorials';
import AdminDiscounts from './pages/admin/Discounts';
import AdminBlog from './pages/admin/Blog';

const queryClient = new QueryClient();
const storefrontEnabled = import.meta.env.VITE_STOREFRONT_ENABLED === 'true';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
            {storefrontEnabled ? (
              <>
                <Route path="/" element={<Layout><Home /></Layout>} />
                <Route path="/shop" element={<Layout><Shop /></Layout>} />
                <Route path="/shop/:slug" element={<Layout><PatternPage /></Layout>} />
                <Route path="/about" element={<Layout><About /></Layout>} />
                <Route path="/faq" element={<Layout><FAQ /></Layout>} />
              </>
            ) : (
              <Route path="/" element={<ComingSoon />} />
            )}
            <Route path="/thank-you" element={<Layout><ThankYou /></Layout>} />
            <Route path="/blog" element={<Layout><Blog /></Layout>} />
            <Route path="/blog/tag/:tag" element={<Layout><BlogTag /></Layout>} />
            <Route path="/blog/:handle" element={<Layout><BlogPost /></Layout>} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/admin/patterns" element={<AdminPatterns />} />
            <Route path="/admin/patterns/preview" element={<Layout><PatternPreview /></Layout>} />
            <Route path="/admin/bundles" element={<AdminBundles />} />
            <Route path="/admin/tutorials" element={<AdminTutorials />} />
            <Route path="/admin/discounts" element={<AdminDiscounts />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
